<div class="sso-page-container">
    <div class="sso-page-card sm:mx-2.28">
        <img src="assets/logo.png" alt="LCPtracker Logo">
        
        <ng-container *ngIf="validated == true">
            <div class="progress-spinner-container">
                <mat-progress-spinner class="example-margin" color="primary" mode="indeterminate" diameter="50">
                </mat-progress-spinner>
            </div>
            <h4 *ngIf="!isLogout">Logging in</h4>
            <h4 *ngIf="isLogout">Logging Out</h4>
            <h5>&nbsp;{{username}}</h5>
            <p>{{statusDescription}}</p>
        </ng-container>
        
        <ng-container *ngIf="validated == false">
            <div class="error-actions">
                <h4>Sorry!</h4>
                <p>There seems to be a problem verifying your name. <b>{{errorDescription}}</b></p>
                <div class="error-links">
                    <a tabindex="0"
                        (click)="goBack()"
                        (keyup.enter)="goBack()"
                        ><span class="material-icons">arrow_back</span> 
                        Dashboard
                    </a>
                <a tabindex="0"
                        (click)="validateToken()"
                        (keyup.enter)="validateToken()"
                        ><span class="material-icons">refresh</span> 
                        Try Again
                    </a>
                <a tabindex="0"
                    (click)="logout()"
                    (keyup.enter)="logout()"
                    ><span class="material-icons">logout</span> 
                    Logout
                </a>
                </div>
                
            </div>
        </ng-container>


    </div>
    <footer></footer>
  </div>
  